import '../less/batch/aui.less';
import '../js/aui.js';



// WEBPACK FOOTER //
// src/entry/aui.js